// ISO-639 language code: two or three alnum characters
export type LanguageCode = string;

export interface PosixLocale {
  language: LanguageCode;
  territory?: string;
  codeset?: string;
  modifier?: string;
}

export function parsePosixLocale(posixLocale: string): PosixLocale {
  // POSIX format for locales: [language[_territory][.codeset][@modifier]]
  const [matchedString, language, territory, codeset, modifier] = Array.from(
    posixLocale.match(/([A-Za-z]+)(?:_([A-Za-z]+))?(?:\.([A-Z-a-z0-9-]+))?(?:@(.*))?/) ||
    []
  )

  if (matchedString !== posixLocale) {
    throw new Error(`could not parse locale '${posixLocale}'`);
  }

  return {
    language: language,
    territory: territory,
    codeset: codeset,
    modifier: modifier,
  }
}


export function getLanguageFromRFC5646LanguageTag(languageTag: string): LanguageCode {
  const [doesMatch, languageCode] = Array.from(languageTag.match(/^([a-z]{2,3})(?:-.*)?$/i) || []);
  if (!doesMatch) {
    throw new Error(`parameter ${languageTag} does not contain language tag`);
  }
  return languageCode;
}
